export const TOAST_TIMEOUT = 8000;
